define.alias("shared/components/shared/card/body", "settings/components/shared/card/body");